<template>
  <ProSpaceRightPanel
    class="user-right-panel"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @edit="editPanel"
    @resetPassword="resetPasswordPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="selectedCount === 1" v-slot:center>
      <ProSpaceTabs :tabs="tabs">
        <template v-slot:tab-1>
          <ProSpacePanelBlock :header="headerOverview">
            <template v-slot:header> </template>
            <template v-slot>
              <ProSpacePanelBlockList :list="content" :items-per-page="5" />
            </template>
          </ProSpacePanelBlock>
        </template>
        <template v-slot:tab-2>
          <ProSpacePanelBlock :header="headerRoles">
            <template v-slot:header>
              <ProSpaceAction :text="`${$t('add')}`" @click="addRole" />
            </template>
            <template v-slot>
              <ProSpaceSimpleGrid
                ref="simple-grid"
                :headers="listHeadersRoles"
                prop-id="securityUserId"
                :service="securityUserRole"
                get-method="grid"
                :modalTitle="$t('roles')"
                :id="selectedData.id"
                :deletable="true"
                :bordered="true"
                :btnText="$t('viewMore')"
                :defaultFilter="{ disabled: { and: [false] } }"
                :confirmDelete="true"
                :confirmTitle="$t('deletingRole')"
                :confirmText="$t('questionDeleting')"
                :confirmObject="$t('role')"
                deletingFieldName="securityRoleDisplayName"
                :selectedAllInShowMore="true"
                @delete="$emit('delete', $event)"
                @apply:delete="$emit('apply:delete', $event)"
                @apply:add="$emit('apply:add', $event)"
              />
            </template>
          </ProSpacePanelBlock>
        </template>
      </ProSpaceTabs>
    </template>
    <template v-if="selectedCount === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
    <template v-if="isMultipleView()" v-slot:center>
      <ProSpaceVLayout :gap="30">
        <ProSpacePanelBlock v-if="isAllRowsSelected" class="prospace-panel-block--empty" :header="{title: $t('itemsSelectedAll')}">
          <template #header>
            <ProSpaceAction
              :text="$t('clearTxt')"
              @click="clearPanelAll"
            />
          </template>
        </ProSpacePanelBlock>
        <PanelBlockSelectedItems :items="[
            { name: $t('id'), value: 'id', f: (v) => v },
            { name: $t('name'), value: 'fullName', f: (v) => v },
          ]"
        />
        <ProSpacePanelBlock :header="headerMultiple">
          <ProSpaceVLayout :gap="15">
            <ProSpaceAction :text="$t('resetPasswordB')" @click="resetPasswordPanel" />
            <ProSpaceAction :text="$t('delete')" @click="deletePanel" />
          </ProSpaceVLayout>
        </ProSpacePanelBlock>
      </ProSpaceVLayout>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
  ProSpaceSimpleGrid,
  ProSpaceModal,
  ProSpaceVLayout
} from "@prospace/prospace-components-library";
import { UserService } from "../../../services/UserService";
import { SecurityUserRole } from "../../../services/SecurityUserRole";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
import {
  useMultiSelectRightPanel,
} from "@composes/multiselect"
import PanelBlockSelectedItems from "@multiselect/PanelBlockSelectedItems"

export default {
  name: "UserPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
    ProSpaceSimpleGrid,
    ProSpaceModal,
    ProSpaceVLayout,
    PanelBlockSelectedItems
  },
  props: {
    model: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    count: {
      type: Number,
      required: true,
    },
    clude: {
      type: Object,
      required: false,
    },
    counterRoles: {
      type: [String, Number],
      default: null
    },
    isAllRowsSelected: {
      type: Boolean,
      default: false
    },
  },
  setup() {
    const { selectedData, selectedClude, selectedCount, isMultipleView } = useMultiSelectRightPanel()
    return {
      selectedData, selectedClude, selectedCount, isMultipleView
    }
  },
  data() {
    return {
      user: null,
      userService: new UserService(),
      securityUserRole: new SecurityUserRole(),
      loading: false,
      hasError: false,
      modelModalClude: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerMultiple() {
      return {
        title: this.$t("actions"),
        isExpand: false,
      };
    },
    headerOverview() {
      return {
        title: this.$t("parameters"),
        isExpand: false,
      };
    },
    headerRoles() {
      return {
        title: this.$t("roles"),
        isExpand: false,
      };
    },
    listHeadersRoles() {
      return [
        { name: this.$t("name"), value: "securityRoleSystemName" },
        { name: this.$t("group"), value: "securityRoleDisplayName" },
      ];
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [
        { name: this.$t("overview"), isActive: true },
        { name: this.$t("roles"), counter: this.counterRoles },
      ];
    },
    header() {
      if (this.user) {
        return {
          title: this.user.secondName
            ? `${this.user.lastName} ${this.user.firstName} ${this.user.secondName}`
            : `${this.user.lastName} ${this.user.firstName}`,
          id: this.user.id,
          status: this.getStatus(this.user.status),
          options: this.options,
          showCounter: false,
        };
      }
      let options = this.options.filter((o) => o.name === "resetPassword");
      return {
        title: this.$t("itemsSelected"),
        counter: this.getCounter,
        showCounter: this.selectedCount > 0 || isNaN(this.selectedCount) ? true : false,
        options: options.length > 0 ? options : null,
      };
    },
    content() {
      if (this.user) {
        return [
          [
            {
              title: this.$t("fio"),
              text: `${this.user.lastName || ""} ${this.user.firstName || ""} ${
                this.user.secondName || ""
              }`,
            },
          ],
          [
            {
              title: this.$t("E-mail"),
              text: this.user.email,
              link: "mailto:" + this.user.email,
            },
          ],
          [
            {
              title: this.$t("Login"),
              text: this.user.login,
            },
          ],
          [
            {
              title: this.$t("SecurityLoginAuthenticateProvider"),
              text: this.user.agencyLinkType,
            },
          ],
          [
            {
              title: this.$t("comment"),
              text: this.user.comment,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.user) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.user.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.user.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.user.createdAt) + ' ' + getAMorPM(this.user.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.user.lastUpdated) + ' ' + getAMorPM(this.user.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
    getCounter() {
      return this.selectedCount || 0;
    }
  },
  mounted() {
    this.update();
  },
  methods: {
    editPanel() {
      this.$emit("edit", this.user);
    },
    clearPanel() {
      if (!this.isAllRowsSelected && (this.count === this.clude.items?.length)) {
        this.$emit("clear");
      } else if (this.isAllRowsSelected && (this.count > this.clude.items?.length) && this.clude.isAll) {
        this.$emit("clear:excluded");
      } else {
        this.$emit("clear");
      }
    },
    clearPanelAll() {
      this.$emit("clear");
    },
    resetPasswordPanel() {
      this.$emit("resetPasswordPanel", this.user);
    },
    deletePanel() {
      this.$emit("delete-item", this.user);
    },
    showHistoryPanel() {
      this.$emit("history-item", this.user);
    },
    async update() {
      this.hasError = false;
      try {
        this.user = await this.getUser();
      } catch (e) {
        this.hasError = true;
      }
    },
    async refreshRoleList() {
      await this.$refs["simple-grid"].getServerData();
    },
    async getUser() {
      if (this.selectedCount === 1 && this.selectedData) {
        this.loading = true;
        const res = this.selectedData.id ? await this.userService.get(this.selectedData.id) : {data: []};
        this.loading = false;
        return res.data;
      }
      return null;
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      switch (status) {
        case "ACTIVE":
          type = "success";
          break;
        case "NEW":
          type = "info";
          break;
        default:
          type = "danger";
      }
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    async deleteRole(role) {
      await this.securityUserRole.delete(role);
      this.update();
    },
    addRole() {
      this.$emit("addRole", this.$refs["simple-grid"].records);
    },
  },
  watch: {
    selectedData() {
      this.update();
    },
    selectedCount() {
      this.update()
    },
  },
};
</script>

<style lang="scss">
.main-grid__modal-style {
  height: 300px;
}
.user-right-panel {
  .prospace-list-items-table {
    .p-datatable-tbody {
      > tr {
        > td {
          &:first-child {
            padding-left: 0;
          }
        }
      }
    }
  }
}
</style>
